import {
  createContext,
  useContext,
  useState,
} from "react";


const UserContext = createContext(undefined);

// Provider component
export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [userProjectPermission, setUserProjectPermission] = useState(null);
  const [viewOnly, setViewOnly] = useState(false);
  const [surveyTallyId, setSurveyTallyId] = useState(null);

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        userProjectPermission, 
        setUserProjectPermission,
        viewOnly, 
        setViewOnly,
        surveyTallyId, 
        setSurveyTallyId
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error(
      "UserContext must be used within a UserProvider"
    );
  }
  return context;
}
